var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "@preppa/translation";
//SKAPA Components
import Button from "@ingka/button";
//SKAPA Icons
import closeIcon from "@ingka/ssr-icon/paths/cross";
// Consumers own the CSS for these class names; this component only provides the shell.
export function Modal(_a) {
    var isModalOpen = _a.isModalOpen, onClose = _a.onClose, children = _a.children, _b = _a.overlayClassName, overlayClassName = _b === void 0 ? "modal-overlay" : _b, _c = _a.containerClassName, containerClassName = _c === void 0 ? "modal-container" : _c, contentClassName = _a.contentClassName, _d = _a.showCloseButton, showCloseButton = _d === void 0 ? true : _d, _e = _a.closeOnOverlayClick, closeOnOverlayClick = _e === void 0 ? true : _e;
    var translate = useTranslation().translate;
    useEffect(function () {
        if (isModalOpen) {
            document.body.classList.add("no-scroll");
        }
        else {
            document.body.classList.remove("no-scroll");
        }
        return function () {
            document.body.classList.remove("no-scroll");
        };
    }, [isModalOpen]);
    if (!isModalOpen)
        return null;
    return (_jsx("div", __assign({ className: overlayClassName, onClick: closeOnOverlayClick ? onClose : undefined }, { children: _jsxs("div", __assign({ className: containerClassName, onClick: function (e) { return e.stopPropagation(); } }, { children: [showCloseButton && (_jsx("header", __assign({ className: "modal-close-button" }, { children: _jsx(Button, { iconOnly: true, size: "xsmall", title: translate("modal.close"), ssrIcon: closeIcon, type: "tertiary", onClick: onClose }) }))), contentClassName ? (_jsx("div", __assign({ className: contentClassName }, { children: children }))) : (children)] })) })));
}
